import { useQuery } from "@tanstack/react-query"
import { makeGetKnowledgeBase } from "@/pages/knowledge-bases/domain/use-cases/get-knowledge-base"
import { httpKnowledgeBaseRepository } from "@/pages/knowledge-bases/data/repositories/knowledge-base-repository"

const getKnowledgeBase = makeGetKnowledgeBase(httpKnowledgeBaseRepository)

export const useKnowledgeBase = (id: string) =>
  useQuery({
    queryKey: ["knowledge-base", id],
    queryFn: () => getKnowledgeBase(id),
    enabled: !!id,
  })
